import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { getColor } from 'helpers/utils';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';

import {
  GridComponent,
  TooltipComponent,
  TitleComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import BasicECharts from 'components/common/BasicEChart';
import { Spinner } from 'reactstrap';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer
]);

const getOptions = (data, radius) => ({
  color: [
    getColor(data[0]?.color),
    getColor(data[1]?.color),
    getColor(data[2]?.color),
    getColor(data[3]?.color),
    getColor(data[4]?.color),
    getColor(data[5]?.color)
  ],

  tooltip: {
    padding: [7, 10],
    transitionDuration: 0,
    backgroundColor: getColor('100'),
    borderColor: getColor('300'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    formatter: params =>
      `<strong>${params.data.name}:</strong> ${params.percent}%`
  },
  series: [
    {
      name: '',
      type: 'pie',
      radius,
      avoidLabelOverlap: false,
      emphasis: {
        scale: false
      },
      itemStyle: {
        borderWidth: 2,
        borderColor: getColor('card-bg')
      },
      label: {
        show: true,
        position: 'center',
        formatter: '{a}',
        fontSize: 23,
        color: getColor('dark')
      },
      data
    }
  ]
});

const SituacaoViagensItens = ({ item, index, total }) => {
  const { name, color, value } = item;

  const percentage = ((parseInt(value) * 100) / total).toFixed(0);
  return (
    <Flex
      alignItems="center"
      justifyContent="between"
      className={`fw-semi-bold fs--2 ${index == 0 && 'mt-3'}`}
    >
      <p className="mb-1">
        <FontAwesomeIcon
          icon="circle"
          className={`me-2 text-${color || 'text-info'}`}
        />
        {name} - {parseInt(value)}
      </p>
      <div className="d-xxl-none">{percentage}%</div>
    </Flex>
  );
};

const SituacaoViagens = ({ data, radius, load }) => {
  // Verificar se data é um array antes de usar reduce
  const safeData = Array.isArray(data) ? data : [];
  const total = safeData.reduce((acc, val) => parseInt(val.value) + acc, 0);

  return (
    <Card className="h-md-100">
      <Card.Body>
        <Row className="justify-content-between g-0">
          <Col xs={5} sm={6} xxl className="pe-2">
            <h6 className="mt-1">
              Situação em viagem
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Situação de viagens em andamento</Tooltip>}
              >
                <span>
                  <FontAwesomeIcon
                    icon={['far', 'question-circle']}
                    transform="shrink-1"
                    className="ms-1 text-400"
                    id="weeklySalesTooltip"
                  />
                </span>
              </OverlayTrigger>
            </h6>
            {load ? (
              <Spinner> </Spinner>
            ) : (
              safeData.map((item, index) => (
                <SituacaoViagensItens
                  item={item}
                  index={index}
                  key={index}
                  total={total}
                />
              ))
            )}
          </Col>
          <Col xs="auto">
            <div className="ps-0">
              {load ? (
                <Spinner className="mt-4"> </Spinner>
              ) : (
                <BasicECharts
                  echarts={echarts}
                  options={getOptions(safeData, radius)}
                  style={{ width: '6.625rem', height: '6.625rem' }}
                />
              )}
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

SituacaoViagensItens.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }),
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired
};

SituacaoViagens.propTypes = {
  data: PropTypes.array.isRequired,
  radius: PropTypes.array.isRequired,
  load: PropTypes.bool.isRequired
};

export default SituacaoViagens;
